import React, { useEffect, useState } from "react";
import { adminApi } from "@/api/adminOneClient";

const TIER_COLORS = { free: "#60B8E8", professional: "#7AC860", executive: "#F5C842", enterprise: "#E8A020" };

export default function AdminRateLimits() {
  const [me, setMe] = useState(null);
  const [quotas, setQuotas] = useState(null);
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const [m, q] = await Promise.all([adminApi.rateLimitMe(), adminApi.rateLimitTiers()]);
      setMe(m.data);
      setQuotas(q.data);
      const prevs = await Promise.all(
        Object.keys(q.data?.quotas_per_hour || {}).map((t) => adminApi.rateLimitPreview(t, 0).then((r) => ({ tier: t, ...r.data })))
      );
      setPreviews(prevs);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  if (loading) return <div className="admin-page mesh-shell" data-testid="admin-rate-limits"><div className="admin-saved">Loading…</div></div>;

  return (
    <div className="admin-page mesh-shell" data-testid="admin-rate-limits">
      <div className="mesh-bg-radar" aria-hidden="true" />
      <div className="mesh-bg-particles" aria-hidden="true" />
      <div className="admin-page__head">
        <h2 className="admin-page__title">Rate Limits</h2>
        <div className="mesh-eyebrow">v13 · Tier-based quotas (requests / hour)</div>
      </div>

      <section className="admin-section mesh-section" data-testid="rl-me">
        <h3 className="admin-section__title">My Quota · Current Hour</h3>
        <div className="mesh-exec-grid">
          <div className="mesh-exec-cell"><div className="mesh-exec-cell__num" style={{ color: TIER_COLORS[me?.tier] || "#F5C842" }}>{(me?.tier || "").toUpperCase()}</div><div className="mesh-exec-cell__lbl">Tier</div></div>
          <div className="mesh-exec-cell"><div className="mesh-exec-cell__num">{me?.unlimited ? "∞" : me?.limit}</div><div className="mesh-exec-cell__lbl">Limit / hour</div></div>
          <div className="mesh-exec-cell"><div className="mesh-exec-cell__num">{me?.used}</div><div className="mesh-exec-cell__lbl">Used</div></div>
          <div className="mesh-exec-cell"><div className="mesh-exec-cell__num">{me?.unlimited ? "∞" : me?.remaining}</div><div className="mesh-exec-cell__lbl">Remaining</div></div>
          <div className="mesh-exec-cell"><div className="mesh-exec-cell__num">{me?.reset_seconds}s</div><div className="mesh-exec-cell__lbl">Reset in</div></div>
          <div className="mesh-exec-cell"><div className="mesh-exec-cell__num" style={{ color: me?.exhausted ? "#C84A3A" : "#7AC860" }}>{me?.exhausted ? "EXHAUSTED" : "OK"}</div><div className="mesh-exec-cell__lbl">Status</div></div>
        </div>
        {!me?.unlimited && (
          <div style={{ marginTop: 10 }}>
            <div className="mship-bar-row__bar" style={{ height: 12 }}>
              <span style={{ width: `${me?.pct_used || 0}%`, background: me?.exhausted ? "#C84A3A" : "#F5C842" }} />
            </div>
            <div className="admin-foot-note" style={{ marginTop: 4 }}>{me?.pct_used}% of hourly quota used</div>
          </div>
        )}
      </section>

      <section className="admin-section mesh-section" data-testid="rl-tiers">
        <h3 className="admin-section__title">Tier Quotas</h3>
        <div className="mship-bars">
          {previews.map((p) => (
            <div key={p.tier} className="mship-bar-row" data-testid={`rl-tier-${p.tier}`}>
              <div className="mship-bar-row__lbl" style={{ color: TIER_COLORS[p.tier] }}>{p.tier.toUpperCase()}</div>
              <div className="mship-bar-row__bar"><span style={{ width: p.unlimited ? "100%" : "35%", background: TIER_COLORS[p.tier] }} /></div>
              <div className="mship-bar-row__num">{p.unlimited ? "unlimited" : `${p.limit} / hr`}</div>
              <div className="mship-bar-row__price" />
            </div>
          ))}
        </div>
        <div className="admin-foot-note" style={{ marginTop: 10 }}>
          Rate limit is advisory by default. Enforcement is opt-in per route via <code>require()</code>; AdminOne super_admin bypasses limits (tier=enterprise = unlimited).
        </div>
      </section>
    </div>
  );
}
